import Warning from '@/src/components/Antd/Modal/WarningModal';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import { NEW } from '@/src/tools/constant';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { Form } from 'antd';
import React, { ReactNode, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { Modal, Skeleton } from 'src/components/Antd';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
import { EnumProductType, EnumStatus } from 'src/types/common/product';
import { EnumReducers } from 'src/types/redux/reducers';
import { onDelete } from '../tools/commonModal/delete';
import { getStatusValue } from '../tools/selectors';
import CustomInfo from './CustomInformation/ProductSetCustomInformationSection';
import Dimensions from './Dimensions/ProductSetDimensionsSection';
import Image from './Images/ProductSetImagesSection';
import Pricing from './Pricing/ProductSetPricingSection';
import ProductInfo from './ProductInfo/ProductSetProductInfoSection';
import Ava from './SalesChannelAvailability';
import Stock from './Stock/ProductSetStockSection';
import Tags from './Tags/ProductSetTagsSection';
import {
  emptyData,
  // validate,
  // submitProduct,
  // getStateSelector,
  // activateProductSet,
  // draftProductSet,
  fetchProduct,
  onHasModifiedChange,
} from './slice';
import { IParams } from './type';

import { cloneDeep } from 'lodash';
import ProductSelection from 'src/pages/ProductEditor/ProductSet/ProductSetSelection/ProductSetSelection';
import { onFinishFailed } from 'src/tools/helper';
import { onDuplicates } from '../tools/commonModal/duplicate';
import { getProductName } from '../tools/getPageName';

// import {
//   productSubmit,
//   productDraft,
//   productActive,
//   productArchive,
// } from '../tools/Submit/ProductSubmit';
import { getProduct } from '@/src/request/product/product';
import { getProduct as getSubmitProduct } from 'src/pages/ProductEditor/tools/Submit/ProductSubmit';
import {
  activateProductThunk as activateProduct,
  archiveProductThunk as archiveProduct,
  draftProductThunk as draftProduct,
  submitProductThunk as submitProduct,
} from 'src/pages/ProductEditor/tools/commonRequests';
import { timeoutScroll } from 'src/tools/helper';
import { switchProductHooks } from '../tools/hooks/customHooks';
import Attributes from './Attribute';

import { useI18n } from 'src/hooks/useRouterChange';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';

const formName = 'ProductSet';

const ProductSet = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const canEdit = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.Products,
        operation: EnumOperation.add_edit_product,
      }),
    ],
  });

  const canDelete = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.Products,
        operation: EnumOperation.delete_product,
      }),
    ],
  });
  const [otherCodeForm] = Form.useForm();
  const [form] = Form.useForm();
  const [discardModal, setDiscardModal] = React.useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>('');

  const handleOnAvaAttOptionsChange = (uuid, option) => {
    const _avaAtt = avaAtt.map((i) => {
      const { uuid: sUid, options } = i;
      if (uuid === sUid) {
        const _o = [...(options || []), option];
        return { ...i, options: _o };
      }
      return i;
    });
    setAvaAtt(_avaAtt);
  };
  const [avaAtt, setAvaAtt] = React.useState([]);
  const [totalStock, setTotalStock] = React.useState(0);
  const dispatch = useDispatch();
  const [modalContent, setModalContent] = useState<ReactNode>('');
  const params: IParams = useParams();
  const { hasModified, loaded, status, uuid } = useSelector(
    getStatusValue(EnumReducers.productSet),
  );

  let { uuid: urlUuid }: any = params;
  const pageTitle = getProductName(
    hasModified,
    loaded,
    urlUuid,
    EnumReducers.productSet,
    EnumProductType.Set,
    { getI18n },
  );

  React.useEffect(() => {
    if (urlUuid === NEW) {
      urlUuid = '';
    }
    // console.log(urlUuid);
    getProduct(urlUuid).then((res: any) => {
      const { product } = res || {};
      const {
        availAttributes,
        attributes,
        taxRules,
        taxRulesEnabled,
        warehouseStocks,
        oversellQuotaEnabled,
        salesChannelStockEnabled,
        //uuid
      } = product || {};
      setAvaAtt(availAttributes || []);
      //console.log('warehouseStocks', warehouseStocks);
      const _stock = (warehouseStocks || []).reduce((pre, now) => {
        const { warehouseStock } = now;
        return pre + warehouseStock || 0;
      }, 0);
      setTotalStock(_stock);
      form.setFieldsValue({
        attributes,
        taxRules,
        taxRulesEnabled,
        warehouseStocks,
        oversellQuotaEnabled,
        salesChannelStockEnabled,
      });
      //console.log('res', res);
      dispatch(fetchProduct(res));
    });
    // .catch(() => {
    //   dispatch(fetchProduct(null));
    // });
    //dispatch(fetchProduct(urlUuid));
    return () => {
      dispatch(emptyData());
    };
  }, []);
  // useAfterDidMountEffect(() => {
  //   history.push(`/product/simpleProduct/${uuid}`);
  // }, [uuid]);
  switchProductHooks(EnumProductType.Set);
  const breadcrumbData = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '/productsList',
      name: getI18n('general.allProducts'),
    },
    {
      url: '',
      name: pageTitle,
    },
  ];

  const publishFields = avaAtt.map((i) => {
    const { uuid } = i;
    return ['attributes', uuid];
  });

  const _getValue = () => {
    const value = form.getFieldsValue();
    return value;
  };

  const handleOnError = (error) => {
    console.log('error', error);
    onFinishFailed(formName, error);
    return false;
  };

  const _getProduct = (s, productType) => {
    //  const fields = status === publishFields;
    const warehouses = form.getFieldValue('warehouseStocks') || [];

    const warehouseKeys = warehouses.reduce((pre, now, index) => {
      return [
        ...pre,
        ['warehouseStocks', index, 'oversellingQuota'],
        ['warehouseStocks', index, 'salesChannelItems'],
      ];
    }, []);

    const rules = ['taxRules', ...warehouseKeys];
    const _status = s || status;
    const fields = _status === EnumStatus.Active ? rules : [];
    const attError = form.getFieldsError(publishFields);
    const errorItem = attError.find((i) => i.errors.length > 0);
    const hasError = !!errorItem;
    if (hasError) {
      // console.log('errorItem', errorItem);
      const { name = [] } = errorItem;
      const pre = formName + '_';
      const suf = name.join('_');
      const id = pre + suf;
      timeoutScroll(id);
      return;
    }
    return form
      .validateFields(fields)
      .then(() => {
        const v = _getValue();
        const reduxProduct = getSubmitProduct(s, productType);
        const p = { ...reduxProduct, ...v };
        console.log('p', p);
        return p;
      })
      .catch(handleOnError);
    // const v = _getValue();
    // const reduxProduct = getSubmitProduct(status, productType);
    // const p = { ...reduxProduct, ...v };
    // //console.log('p', p);
    // return p;
  };

  // const [okText, setOkText] = useState<string>('');
  const onModalCancel = () => {
    setShowModal(false);
  };

  const onSubmit = (params?) => {
    const productType = EnumProductType.Set;
    // productSubmit({ ...(params || {}), productType: EnumProductType.Simple });
    const { cb, hideMsg, status } = params || {};
    const product = _getProduct(status, productType);
    if (product) {
      product.then((product) => {
        if (product) {
          const { dataValid } = product;
          if (dataValid) {
            dispatch(submitProduct({ prod: product, hideMsg }));
            if (cb) cb(product);
          }
        }
      });
    }
  };
  const setDraft = () => {
    const product = _getProduct(EnumStatus.Draft, EnumProductType.Set);
    if (product) {
      product.then((product) => {
        if (product) {
          const { dataValid } = product;
          if (dataValid) {
            dispatch(draftProduct(product));
          }
        }
      });
    }
    // productDraft({ productType: EnumProductType.Set });
  };
  const setActive = () => {
    const product = _getProduct(EnumStatus.Active, EnumProductType.Set);
    if (product) {
      product.then((product) => {
        if (product) {
          const { dataValid } = product;
          if (dataValid) {
            dispatch(activateProduct(product));
          }
        }
      });
    }

    // productActive({ productType: EnumProductType.Set });
  };

  const setArchived = () => {
    const product = _getProduct(EnumStatus.Archived, EnumProductType.Set);
    if (product) {
      product.then((product) => {
        if (product) {
          const { dataValid } = product;
          if (dataValid) {
            dispatch(archiveProduct(product));
          }
        }
      });
    }
    // productArchive({ productType: EnumProductType.Set });
  };

  const history = useHistory();

  const goBackToList = () => {
    history.push('/productsList');
  };

  const _delete = () => {
    onDelete(uuid, setShowModal, setModalContent, setModalTitle);
  };

  const _duplicate = () => {
    const processData = (prod) => {
      const { attributes, warehouseStocks } = prod;
      const _warehouseStocks = (warehouseStocks || []).map((i) => {
        const { salesChannelItems } = i || {};
        const _salesChannelItems = (salesChannelItems || []).map((item) => {
          return {
            ...(item || {}),
            availableQuantity: 0,
          };
        });
        return {
          ...(i || {}),
          oversellingQuota: 0,
          totalAvailableForSale: 0,
          unassignedAvailableForSale: 0,
          warehouseStock: 0,
          salesChannelItems: _salesChannelItems,
        };
      });
      const isUnique = avaAtt.filter((i) => i.unique).map((i) => i.uuid);
      const _attributes = cloneDeep(attributes);
      isUnique.forEach((i) => {
        _attributes[i] = null;
      });

      form.setFieldsValue({
        taxRules: [],
        attributes: _attributes,
        warehouseStocks: _warehouseStocks,
      });
      prod.sku = null;
      prod.warehouseStocks = _warehouseStocks;
      return prod;
    };
    onDuplicates(
      onSubmit,
      setShowModal,
      setModalContent,
      setModalTitle,
      status,
      processData,
    );
  };
  const topRight = (
    <TopLeft goBack={goBackToList} breadcrumbData={breadcrumbData} />
  );

  const topLeft = (
    <TopRight
      onSubmit={() => {
        onSubmit();
      }}
      onDiscard={goBackToList}
      onSaveDisable={canEdit ? !hasModified : true}
      displayDuplicateGroup={!!uuid && status !== EnumStatus.Archived}
      onDelete={canDelete ? _delete : null}
      onCopy={canEdit ? _duplicate : null}
      status={status}
    />
  );
  const Child = [
    {
      child: (
        <ProductInfo
          pageTitle={pageTitle}
          setModalContent={setModalContent}
          setModalTitle={setModalTitle}
          otherCodeForm={otherCodeForm}
          setShowModal={setShowModal}
          // setOkText={setOkText}
          setDraft={setDraft}
          setActive={setActive}
          setArchived={setArchived}
          disabled={!canEdit}
        />
      ),
    },
    {
      child: (
        <Attributes
          avaAtt={avaAtt}
          onAttOptionsChange={handleOnAvaAttOptionsChange}
          productUuid={urlUuid === NEW ? null : urlUuid}
          disabled={!canEdit}
        />
      ),
    },
    {
      child: <Tags disabled={!canEdit} />,
    },
    { child: <Image disabled={!canEdit} /> },
    { child: <ProductSelection totalStock={totalStock} disabled={!canEdit} /> },
    {
      child: (
        <Stock
          disabled={!canEdit}
          uuid={urlUuid}
          form={form}
          //warehouses={warehouses}
          title={getI18n('allProducts.addproductset.general_stock_title')}
          secondTitle={getI18n(
            'allProducts.addproductset.general_stock_secondTitle',
          )}
        />
      ),
    },
    {
      child: (
        <Pricing
          productUuid={urlUuid === NEW ? null : urlUuid}
          disabled={!canEdit}
        />
      ),
    },

    {
      child: <Dimensions disabled={!canEdit} />,
    },

    {
      child: <CustomInfo disabled={!canEdit} />,
    },
    {
      child: <Ava disabled={!canEdit} />,
    },
  ];
  const toProductList = () => {
    history.push('/productsList');
  };

  return (
    <React.Fragment>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18n('general.leave')}
        active={hasModified && !discardModal}
        title={getI18nFromGeneral('general.commonHeader.leave_header')}
        content={getI18nFromGeneral('general.commonHeader.leave_content')}
      />

      <Warning
        header={getI18nFromGeneral('general.commonHeader.discard_header')}
        onCancel={() => {
          setDiscardModal(false);
        }}
        cancelText={getI18n(
          'allProducts.addproductset.general_Discard_cancelText',
        )}
        onOk={toProductList}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        visible={discardModal}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}>
        <span>
          {getI18n('allProducts.addproductset.general_Discard_content')}
        </span>
      </Warning>
      <Form
        form={form}
        name={formName}
        onValuesChange={() => {
          dispatch(onHasModifiedChange());
        }}>
        <Skeleton loading={!loaded} active>
          <Layout elements={Child} topLeft={topRight} topRight={topLeft} />
        </Skeleton>
      </Form>
      <Modal
        visible={showModal}
        title={modalTitle}
        onCancel={onModalCancel}
        cancelText={getI18n('general.cancel')}>
        {modalContent}
      </Modal>
    </React.Fragment>
  );
};

export default ProductSet;
